<template>
  <div id="app">
    <router-view />
    <portal-target name="ModalRecommendation" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@use "vue-select/src/scss/vue-select";
@import "~vue2-datepicker/index.css";
@import "~bootstrap/dist/css/bootstrap.css";
@import "~font-awesome/css/font-awesome.min.css";
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

a {
  cursor: pointer;
}

.btn:focus,
input:focus,
textarea:focus,
select:focus {
  box-shadow: none !important;
}

::-ms-reveal {
  display: none;
}

.bg-purple-light {
  background-color: #f5efff;
}

.bg-danger-light {
  background-color: #ffaeae !important;
}

.password-reveal {
  color: #999;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;

  .is-invalid + & {
    display: none;
  }
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.5)
}

.v-select {
  .input-group & {
    flex: 1 1 auto;
    width: 1%;
  }

  &.sm {
    font-size: 0.875rem;
  }
}

.vs__dropdown-toggle {
  white-space: nowrap;
}

.vs__selected-options {
  overflow: hidden;
}

.vs__dropdown-option--disabled {
  color: black;
  font-weight: bold;
  padding: 3px 10px;
  text-transform: capitalize;
}

.vs__dropdown-toggle .vs__actions svg {
  vertical-align: initial;
}
</style>
